import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loginUser } from "../../actions/authActions";
import "./Auth.scss";

class Login extends Component {
	constructor() {
		super();
		this.state = {
			email: "",
			password: "",
			errors: {},
			errorMessage: null
		};
	}

	componentDidMount() {
		if (this.props.auth.isAuthenticated) {
			this.props.history.push("/dashboard");
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.auth && (this.props.auth.error !== prevProps.auth.error)) {
			this.setState({
				errorMessage: this.props.auth.error
			})
		}
		
		if (this.props.auth.isAuthenticated) {
			this.props.history.push("/dashboard");
		}
		
		if (this.props.errors) {
			this.setState({
				errors: this.props.errors
			});
		}
	}


	onChange = e => {
		this.setState({ [e.target.id]: e.target.value });
	};


	validarEmail(email) {
		const emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
		if (emailRegex.test(email)) {
			return true
		} else {
			return false
		}
	}

	onSubmit = e => {
		let isValidPassword = true;
		let isValidEmail    = true;
		e.preventDefault();
		if (this.state.password === "") {
			this.setState({
				errorPassword: "La contraseña es requerida",
			})
			isValidPassword = false
		}

		if (this.state.email === "") {
			this.setState({
				errorEmail: "El correo  es requerido.",
			})
			isValidEmail = false
		} else if (!this.validarEmail(this.state.email)) {
			this.setState({
				errorEmail: "El correo  es inválido.",

			})
			isValidEmail = false
		}
		if (isValidEmail && isValidPassword) {
			const userData = {
				email: this.state.email,
				password: this.state.password,
			};
			this.props.loginUser(userData);
		}
	};


	render() {
		return (
			<div className="base-wrapper">
				<form
					ref={(el) => { this.farmazonLoginRef = el }}
					className="auth-form" noValidate onSubmit={this.onSubmit}>

					<div className="auth-group">
						<img src="../../logo.png" alt="Farmazon CMS" className="imgMall" />
						<br></br>
						<br></br>
						<label>
							<div className="auth-label">Usuario</div>
							<input
								onChange={this.onChange}
								value={this.state.email}
								error={this.state.errorEmail}
								id="email"
								type="email"
								className="auth-input"
								placeholder="Ej.: admin@farmazon.com"
								style={{ fontSize: 16 }}
							/>
							<div className="auth-error">
								{this.state.errorEmail}
							</div>
						</label>
					</div>

					<div className="auth-group">
						<label>
							<div className="auth-label">Password</div>
							<input
								onChange={this.onChange}
								value={this.state.password}
								error={this.state.errorPassword}
								id="password"
								type="password"
								className="auth-input"
								style={{ fontSize: 16 }}
							/>
							<div className="auth-error">
								{this.state.errorPassword}
							</div>
						</label>
					</div>

					<div>
						<button type="submit" className="auth-button">
							Entrar
						</button>
						<div className="auth-error">
							{this.state.errorMessage}
						</div>
					</div>

				</form>
			</div>
		);
	}
}

Login.propTypes = {
	loginUser: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired,
	errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
	auth: state.auth,
	errors: state.errors
});

export default connect(mapStateToProps, { loginUser })(Login);

